import styled from 'styled-components'

const DefaultButton = styled.button`
  align-items: center;
  background-color: #fff;
  border: 1px solid #999;
  display: flex;
  font-size: 14px;
  justify-content: center;

  &:hover {
    background-color: #f2f8ff;
    color: #457ab5;
  }

  &:active {
    color: #dae5f2;
  }
`

export default DefaultButton
